<template>
  <loader v-if="loading"></loader>
  <find-page-layout
    v-else
    :breadcrumbs="breadcrumbs"
    :filters="filters"
    :page-request="pageRequest"
    :sorters="sorters"
    :page="page"

    :filters-title="'Ricerca ' + label"
    :results-title="label"
    no-results-message="Nessuna analisi trovata"

    @selectPageSize="selectPageSize"
    @find="find"
    @sort="sortBy"
    @selectPage="selectPage">
    <b-card slot="filters">
      <component :is="filtersComponent" v-model="filters" />
    </b-card>
    <b-row slot="results">
      <b-col v-for="r in page.content" sm="6" md="4">
        <router-link-card
          :disabled="!r.permissions.load"
          :to="{ name: loadPage, params: { analysisId: r.analysis.id, id: r.id } }">
          <div slot="header">
            <div class="font-weight-bold">{{ r.analysis.title }}</div>
            <div>{{ r.title }}</div>
          </div>
          <div>
            <info-field labelClass="col" label="Proprietario">
              {{ r.owner.displayName }}
            </info-field>
            <info-field labelClass="col" label="Gruppo di lavoro">
              <workgroup-input-field
                :value="r.analysis.workgroup"
                disabled
                plaintext
              />
            </info-field>
          </div>
          <div class="mt-2 border-top border-secondary pt-2">
            {{ r.description || '&lt;Nessuna descrizione&gt;' }}
          </div>
          <div class="text-right mt-2" v-if="r.permissions.load">
            <b-button
              variant="outline-success"
              size="sm"
              :to="{ name: clonePage, params: { analysisId: r.analysis.id, id: 'clone', originalId: r.id } }">
              <i class="fa fa-fw fa-copy"></i>
              Clona
            </b-button>
          </div>
        </router-link-card>
      </b-col>
    </b-row>
    <div
      v-if="$route.params.analysisId !== 'all' && page.permissions && page.permissions.create"
      slot="bottom-buttons"
      class="text-right mb-2">
      <b-button variant="success" :to="{ name: loadPage, params: { analysisId: $route.params.analysisId, id: 'new' } }">
        Nuovo
      </b-button>
    </div>
  </find-page-layout>
</template>
<script>
import FindPageMixin from 'vue-core/mixins/FindPageMixin';

export default {
  mixins: [ FindPageMixin ],

  computed: {
    breadcrumbs() {
      let item;
      if (this.$route.params.analysisId === 'all') {
        item = {
          label: 'Tutte',
          disabled: true,
        };
      } else {
        item = {
          label: this.$route.params.analysisId,
          link: '/protected/analyses/' + this.$route.params.analysisId,
          component: 'analysis-input-field',
          props: {
            inputId: true,
            disabled: true,
            plaintext: true,
            value: this.$route.params.analysisId,
          }
        };
      }

      return [
        {
          label: 'Home',
          link: '/protected'
        },
        {
          label: 'Analisi',
          link: '/protected/analyses'
        },
        item,
        {
          label: this.label,
        },
      ];
    },

    sorters() {
      return [
        {
          label: 'Id',
          path: 'id'
        },
      ];
    }
  },

  methods: {
    find() {
      if (this.forceFilters) {
        this.forceFilters();
      }

      let parameters = this.filters;
      const routeAnalysisId = this.getRouteAnalysisId();
      if (routeAnalysisId) {
        parameters = {
          ...parameters,
          analysisIds: [routeAnalysisId]
        };
      }

      this.loading = true;
      this.service.find({
        analysisId: this.$route.params.analysisId && this.$route.params.analysisId,
        parameters,
        pageRequest: this.pageRequest,
        sort: this.sort
      }).then(this.onFindSuccess, this.onFindError);
    },

    getRouteAnalysisId() {
      if (this.$route.params.analysisId && this.$route.params.analysisId !== 'all') {
        return parseInt(this.$route.params.analysisId, 10);
      } else {
        return undefined;
      }
    }
  }
};
</script>
